/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
    // Add custom code below this line
    if (!customElements.get('pickup-availability-notification')) {
        customElements.define('pickup-availability-notification', class PickupAvailability extends HTMLElement {
            constructor() {
                super();

                this.fetchAvailability(this.dataset.variantId);
            }

            fetchAvailability(variantId) {
                let rootUrl = this.dataset.rootUrl;
                if (!rootUrl.endsWith("/")) {
                    rootUrl = rootUrl + "/";
                }
                const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability-notification`;

                fetch(variantSectionUrl)
                    .then(response => {
                        return response.text()
                    }).then((text) => {
                    const sectionInnerHTML = new DOMParser()
                        .parseFromString(text, 'text/html')
                        .querySelector('.shopify-section');
                    this.renderPreview(sectionInnerHTML);
                })
                    .catch(e => {
                        console.log('error')
                    });
            }


            renderPreview(sectionInnerHTML) {
                this.setAttribute('available', '');
                this.innerHTML = sectionInnerHTML.querySelector('.pickup-availability-notification').outerHTML;
            }
        });

        document.addEventListener('theme:variant:change', function (event) {
            const variant = event && event.detail ? event.detail.variant : null;
            if (!variant) return;

            // Every element below is optional depending on theme settings and
            // product state, so each is guarded. The previous version bailed out
            // early whenever pickup availability was disabled (which it is), so
            // none of the add-to-cart logic ever ran.
            const pickUpAvailabilityNotification = document.querySelector('pickup-availability-notification');
            const klaviyoVariant = document.getElementById('klaviyo-variant');
            const klaviyoMessage = document.getElementById('klaviyo-message');
            const backInStock = document.getElementById('klaviyo-back-in-stock');
            const submitItem = document.querySelector('.product__submit__item');
            const quantityPopout = submitItem ? submitItem.querySelector('.select-popout') : null;
            const addToCart = document.querySelector('button.btn[data-add-to-cart]');

            if (klaviyoVariant) klaviyoVariant.value = variant.id;
            if (klaviyoMessage) klaviyoMessage.textContent = '';

            if (variant.available) {
                if (pickUpAvailabilityNotification) pickUpAvailabilityNotification.fetchAvailability(variant.id);
                if (backInStock) backInStock.style.display = 'none';
                if (submitItem) submitItem.classList.remove('sold');
                if (quantityPopout) quantityPopout.style.display = 'block';
                // Liquid stamps an inline display:none on the button when the
                // product's default variant is sold out. theme.js only toggles
                // the disabled attribute, never this style, so without the line below the
                // button never reappears when an in-stock variant is selected.
                if (addToCart) addToCart.style.display = 'block';
            } else {
                if (pickUpAvailabilityNotification) pickUpAvailabilityNotification.removeAttribute('available');
                if (backInStock) backInStock.style.display = 'flex';
                if (submitItem) submitItem.classList.add('sold');
                if (quantityPopout) quantityPopout.style.display = 'none';
                if (addToCart) addToCart.style.display = 'none';
            }
        });
    }

    document.addEventListener('theme:drawer:open', (event) => {
        const headerSearchForm = document.querySelector('.header__mobile header-search-form');
        const isHeaderSticky = !!document.querySelector('[data-header-sticky]')

        if (!headerSearchForm) return;

        const rect = headerSearchForm.getBoundingClientRect();
        const scrollY = isHeaderSticky ? 0 : window.scrollY;

        event?.target?.style?.setProperty("--offset", `${rect.top + scrollY + headerSearchForm.offsetHeight}px`);
    });
    /**
     * Video reviews (sections/section-video-reviews.liquid) and
     * video spotlight (sections/section-video-spotlight.liquid)
     *
     * Cards render a poster image plus a <template> holding the real player.
     * Nothing loads until the viewer presses play, so a grid of eight reviews
     * costs eight images rather than eight video players.
     */
    document.addEventListener('click', function (event) {
        const trigger = event.target.closest('[data-video-review-play]');
        if (!trigger) return;

        const media = trigger.parentElement;
        if (!media) return;

        const template = media.querySelector('[data-video-review-template]');
        if (!template) return;

        const player = template.content.cloneNode(true);
        media.replaceChildren(player);

        // Uploaded videos can start straight away; embeds handle their own autoplay.
        const video = media.querySelector('video');
        if (video && typeof video.play === 'function') {
            video.play().catch(function () {
                /* autoplay blocked - the controls are visible, so leave it paused */
            });
        }
    });

    /**
     * Video spotlight carousel (sections/section-video-spotlight.liquid)
     *
     * Swiper slider (assets/swiper.min.js, loaded before this file in
     * layout/theme.liquid) with slidesPerView "auto", so the card width set
     * in CSS is the slide width. Arrows fade at either end and hide when
     * every card already fits. Without Swiper the section gets a class that
     * turns the track back into a native horizontal scroller. Only one clip
     * plays at a time: starting one pauses the others in the same track.
     */
    function setupVideoSpotlight(carousel) {
        if (carousel.dataset.spotlightReady) return;
        carousel.dataset.spotlightReady = 'true';

        const container = carousel.querySelector('[data-video-spotlight-swiper]');
        const track = carousel.querySelector('[data-video-spotlight-track]');
        if (!container || !track) return;

        track.addEventListener('play', function (event) {
            track.querySelectorAll('video').forEach(function (video) {
                if (video !== event.target && !video.paused) video.pause();
            });
        }, true);

        if (typeof Swiper === 'undefined') {
            carousel.classList.add('video-spotlight--no-swiper');
            return;
        }

        const isMobile = window.matchMedia('(max-width: 749px)').matches;

        carousel.spotlightSwiper = new Swiper(container, {
            slidesPerView: 'auto',
            spaceBetween: isMobile ? 12 : 16,
            slidesPerGroupAuto: true,
            speed: 420,
            grabCursor: true,
            watchOverflow: true,
            observer: true,
            observeParents: true,
            observeSlideChildren: true,
            updateOnWindowResize: true,
            navigation: {
                prevEl: carousel.querySelector('[data-video-spotlight-prev]'),
                nextEl: carousel.querySelector('[data-video-spotlight-next]'),
                disabledClass: 'is-disabled',
                lockClass: 'is-locked'
            },
            breakpoints: {
                750: { spaceBetween: 16 }
            }
        });
    }

    function initVideoSpotlights(root) {
        (root || document).querySelectorAll('[data-video-spotlight]').forEach(setupVideoSpotlight);
    }

    document.addEventListener('DOMContentLoaded', function () { initVideoSpotlights(document); });
    document.addEventListener('shopify:section:load', function (event) { initVideoSpotlights(event.target); });
    document.addEventListener('shopify:section:unload', function (event) {
        event.target.querySelectorAll('[data-video-spotlight]').forEach(function (carousel) {
            if (carousel.spotlightSwiper) {
                carousel.spotlightSwiper.destroy(true, true);
                carousel.spotlightSwiper = null;
            }
        });
    });

    /**
     * Cart upsell eyebrow, aware of the free-shipping threshold.
     *
     * "Add $23 for free shipping" converts better than a static label when
     * the customer is close to the threshold. Falls back to the plain label
     * once they qualify, or if the progress bar is not on the page.
     */
    function updateAddonsHeading() {
        const eyebrow = document.querySelector('[data-cart-upsell-eyebrow]');
        if (!eyebrow) return;

        if (!eyebrow.dataset.defaultLabel) {
            eyebrow.dataset.defaultLabel = eyebrow.textContent.trim();
        }

        const bar = document.querySelector('[data-free-shipping]');
        const left = document.querySelector('[data-left-to-spend]');
        const qualified = !bar || bar.classList.contains('is-success');

        if (qualified || !left || !left.textContent.trim()) {
            eyebrow.textContent = eyebrow.dataset.defaultLabel;
        } else {
            eyebrow.textContent = 'Add ' + left.textContent.trim() + ' for free shipping';
        }
    }

    document.addEventListener('theme:cart:change', updateAddonsHeading);
    document.addEventListener('DOMContentLoaded', updateAddonsHeading);

    /**
     * Cart upsell slider (snippets/cart-drawer.liquid, .cart-upsell).
     *
     * Powered by Swiper (assets/swiper.min.js, loaded before this
     * file in layout/theme.liquid). Products come only from Theme settings >
     * Cart > Upsell products.
     *
     * The drawer is AJAX: theme.js swaps [data-upsell-products].innerHTML
     * (our .swiper-wrapper) on every cart change and toggles is-hidden on
     * [data-upsell-widget]. A MutationObserver on the wrapper rebuilds the
     * slider whenever that happens, independent of event order, and the
     * drawer open event re-measures once the panel is on screen.
     */
    const CartUpsell = {
        widget: null,
        track: null,
        swiper: null,
        observer: null,
        rebuildTimer: 0,

        setup: function () {
            this.widget = document.querySelector('[data-cart-upsell]');
            if (!this.widget) return false;

            this.track = this.widget.querySelector('[data-cart-upsell-track]');
            if (!this.track) return false;

            if (!this.observer) {
                this.observer = new MutationObserver(() => this.scheduleRebuild());
                this.observer.observe(this.track, { childList: true });
            }

            return true;
        },

        scheduleRebuild: function () {
            clearTimeout(this.rebuildTimer);
            this.rebuildTimer = setTimeout(() => this.rebuild(), 40);
        },

        cartHasItems: function () {
            const drawer = document.querySelector('[data-cart-drawer]');
            return !!(drawer && drawer.querySelector('[data-items-holder] [data-item]'));
        },

        rebuild: function () {
            if (!this.setup()) return;

            const slides = this.track.querySelectorAll('.swiper-slide');

            if (!slides.length || !this.cartHasItems()) {
                this.destroy();
                this.widget.classList.add('is-hidden');
                return;
            }

            this.widget.classList.remove('is-hidden');

            if (typeof Swiper === 'undefined') {
                // Library missing: CSS keeps the cards in a scrollable row.
                this.widget.classList.add('cart-upsell--no-swiper');
                return;
            }

            this.destroy();

            const container = this.widget.querySelector('[data-cart-upsell-swiper]');
            const inner = parseFloat(getComputedStyle(this.widget).getPropertyValue('--inner')) || 20;
            const self = this;

            this.swiper = new Swiper(container, {
                slidesPerView: 'auto',
                spaceBetween: 10,
                speed: 420,
                grabCursor: true,
                watchOverflow: true,
                observer: true,
                observeParents: true,
                observeSlideChildren: true,
                updateOnWindowResize: true,
                slidesOffsetBefore: inner,
                slidesOffsetAfter: inner,
                navigation: {
                    prevEl: this.widget.querySelector('[data-cart-upsell-prev]'),
                    nextEl: this.widget.querySelector('[data-cart-upsell-next]'),
                    disabledClass: 'is-disabled',
                    lockClass: 'is-locked'
                },
                pagination: {
                    el: this.widget.querySelector('[data-cart-upsell-dots]'),
                    clickable: true,
                    bulletClass: 'cart-upsell__dot',
                    bulletActiveClass: 'is-active',
                    lockClass: 'is-locked'
                },
                on: {
                    init: function (swiper) { self.syncOverflow(swiper); },
                    resize: function (swiper) { self.syncOverflow(swiper); },
                    update: function (swiper) { self.syncOverflow(swiper); },
                    lock: function (swiper) { self.syncOverflow(swiper); },
                    unlock: function (swiper) { self.syncOverflow(swiper); }
                }
            });

            // Card images load after the drawer opens; re-measure once they settle.
            this.refresh(400);
        },

        refresh: function (delay) {
            const self = this;
            setTimeout(function () {
                if (self.swiper) self.swiper.update();
            }, delay || 0);
        },

        syncOverflow: function (swiper) {
            if (!this.widget) return;
            this.widget.classList.toggle('has-overflow', !swiper.isLocked);
        },

        destroy: function () {
            if (this.swiper) {
                this.swiper.destroy(true, true);
                this.swiper = null;
            }
        }
    };

    document.addEventListener('DOMContentLoaded', function () { CartUpsell.rebuild(); });

    // theme.js fires this after swapping the upsell markup; the observer usually
    // beats it, but a rebuild is cheap and this also covers the empty-cart case.
    document.addEventListener('theme:cart:change', function () { CartUpsell.scheduleRebuild(); });

    // Re-measure once the drawer panel is actually on screen (0.6s slide-in).
    document.addEventListener('theme:cart:open', function () {
        if (!CartUpsell.swiper) {
            CartUpsell.scheduleRebuild();
        }
        CartUpsell.refresh(100);
        CartUpsell.refresh(700);
    });

    // ^^ Keep your scripts inside this IIFE function call to
    // avoid leaking your variables into the global scope.

    /**
     * Product card colour dots.
     *
     * The GridSwatch element fills each dot with `--swatch: var(--{name})`,
     * which only resolves for names listed in assets/swatches.css. Woven wrap
     * colourways ("Graphite", "Sage Ombre") are not in that list, so every dot
     * fell back to grey. When the variant has a photo, paint that instead.
     */
    function paintCardSwatches(root) {
        const scope = root && root.querySelectorAll ? root : document;
        const buttons = scope.querySelectorAll('.product-item [data-swatch-button][data-swatch-image]');

        buttons.forEach(function (button) {
            if (button.dataset.swatchPainted) return;

            const link = button.querySelector('.swatch__link');
            const image = button.dataset.swatchImage;
            if (!link || !image) return;

            // A resolvable --swatch means the colour is defined; keep the flat colour.
            const resolved = getComputedStyle(button).getPropertyValue('--swatch').trim();
            if (resolved) {
                button.dataset.swatchPainted = 'color';
                return;
            }

            const src = image.indexOf('?') === -1 ? image + '?width=96' : image + '&width=96';
            link.style.backgroundImage = 'url("' + src + '")';
            button.dataset.swatchPainted = 'image';
        });
    }

    const swatchObserver = new MutationObserver(function (mutations) {
        for (const mutation of mutations) {
            for (const node of mutation.addedNodes) {
                if (node.nodeType !== Node.ELEMENT_NODE) continue;
                if (node.matches('[data-swatch-button]') || node.querySelector('[data-swatch-button]')) {
                    paintCardSwatches(node.closest('.product-item') || node);
                }
            }
        }
    });

    swatchObserver.observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('DOMContentLoaded', function () { paintCardSwatches(document); });

})();
